'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V10.6667H0V20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 10.6667H28V0H0V10.6667Z",
          fill: "#DD2137"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.1978 11.5527C16.3641 11.261 16.4961 10.9434 16.5871 10.6039C17.1589 8.47003 15.8926 6.27669 13.7587 5.70492C13.403 5.60962 13.0375 5.82068 12.9422 6.17632C12.8469 6.53197 13.058 6.89753 13.4136 6.99282C14.8362 7.374 15.6804 8.83623 15.2992 10.2588C15.2469 10.4541 15.1742 10.6385 15.084 10.8103L13.0365 9.44526C12.7302 9.24102 12.3163 9.32381 12.112 9.63016C11.9078 9.93651 11.9906 10.3504 12.2969 10.5547L14.1742 11.8061C13.5628 12.2023 12.7923 12.3478 12.0332 12.1444C11.6776 12.0491 11.312 12.2602 11.2167 12.6158C11.1214 12.9715 11.3325 13.337 11.6881 13.4323C13.0213 13.7895 14.3777 13.4293 15.3473 12.5883L16.2969 13.2213C16.6033 13.4256 17.0172 13.3428 17.2214 13.0364C17.4257 12.7301 17.3429 12.3162 17.0365 12.1119L16.1978 11.5527Z",
          fill: "#F8D84B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.6666 8.66665C13.0348 8.66665 13.3333 8.36818 13.3333 7.99999C13.3333 7.6318 13.0348 7.33332 12.6666 7.33332C12.2984 7.33332 12 7.6318 12 7.99999C12 8.36818 12.2984 8.66665 12.6666 8.66665Z",
          fill: "#F8D84B"
        }
      )
    ]
  }
);
const VpFlagAoAsset = forwardRef(FlagAoAsset);

export { VpFlagAoAsset as default };
